module.exports = __webpack_public_path__ + "img/31_newYouth_zxq.f742f026.png";